import {CARTESIAN_CHART_TYPES, RADIAL_CHART_TYPES} from "../chart/constants";
import {VIEWER_TABLE_TYPE} from "../odata-viewer/constants";

export const AGGREGATIONS = {
  sum: "sum",
  avg: "average",
  min: "min",
  max: "max"
};

export const DEFAULT_AGGREGATION = AGGREGATIONS.sum;

export const aggregationList = t => [
  {id: AGGREGATIONS.sum, label: t("components.resourcePivoting.aggregationList.sum")},
  {id: AGGREGATIONS.avg, label: t("components.resourcePivoting.aggregationList.avg")},
  {id: AGGREGATIONS.min, label: t("components.resourcePivoting.aggregationList.min")},
  {id: AGGREGATIONS.max, label: t("components.resourcePivoting.aggregationList.max")}
];

export const getAggregationLabels = t => ({
  [AGGREGATIONS.sum]: t("components.resourcePivoting.aggregationList.sum"),
  [AGGREGATIONS.avg]: t("components.resourcePivoting.aggregationList.avg"),
  [AGGREGATIONS.min]: t("components.resourcePivoting.aggregationList.min"),
  [AGGREGATIONS.max]: t("components.resourcePivoting.aggregationList.max")
});

export const getCurrentViewerLabel = (t, viewer) => {
  if (viewer === VIEWER_TABLE_TYPE) {
    return t("components.resourcePivoting.viewer.label.table");
  } else if (CARTESIAN_CHART_TYPES.includes(viewer)) {
    return t("components.resourcePivoting.viewer.label.chartCartesian");
  } else if (RADIAL_CHART_TYPES.includes(viewer)) {
    return t("components.resourcePivoting.viewer.label.chartRadial");
  } else {
    return t("components.resourcePivoting.viewer.label.map");
  }
};

export const COUNT_MEASURE = "$count";

export const getCountMeasure = t => ({
  id: COUNT_MEASURE,
  type: "COUNT",
  title: t("components.resourcePivoting.countMeasure.title")
});
